/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { DareStatDto } from '../models';
import { DareStatDtoPagedResponse } from '../models';
/**
 * DareCreationApi - axios parameter creator
 * @export
 */
export const DareCreationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DareStatDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDareCreationCreatePut: async (body?: DareStatDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DareCreation/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDareCreationDeleteDelete: async (server?: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DareCreation/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DareStatDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDareCreationEditPost: async (body?: DareStatDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DareCreation/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {boolean} [isDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDareCreationGetGet: async (server?: string, page?: number, itemsPerPage?: number, isDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DareCreation/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DareCreationApi - functional programming interface
 * @export
 */
export const DareCreationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DareStatDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationCreatePut(body?: DareStatDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await DareCreationApiAxiosParamCreator(configuration).apiDareCreationCreatePut(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await DareCreationApiAxiosParamCreator(configuration).apiDareCreationDeleteDelete(server, name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {DareStatDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationEditPost(body?: DareStatDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await DareCreationApiAxiosParamCreator(configuration).apiDareCreationEditPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {boolean} [isDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationGetGet(server?: string, page?: number, itemsPerPage?: number, isDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DareStatDtoPagedResponse>>> {
            const localVarAxiosArgs = await DareCreationApiAxiosParamCreator(configuration).apiDareCreationGetGet(server, page, itemsPerPage, isDeleted, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DareCreationApi - factory interface
 * @export
 */
export const DareCreationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {DareStatDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationCreatePut(body?: DareStatDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return DareCreationApiFp(configuration).apiDareCreationCreatePut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return DareCreationApiFp(configuration).apiDareCreationDeleteDelete(server, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DareStatDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationEditPost(body?: DareStatDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return DareCreationApiFp(configuration).apiDareCreationEditPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {boolean} [isDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDareCreationGetGet(server?: string, page?: number, itemsPerPage?: number, isDeleted?: boolean, options?: AxiosRequestConfig): Promise<AxiosResponse<DareStatDtoPagedResponse>> {
            return DareCreationApiFp(configuration).apiDareCreationGetGet(server, page, itemsPerPage, isDeleted, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DareCreationApi - object-oriented interface
 * @export
 * @class DareCreationApi
 * @extends {BaseAPI}
 */
export class DareCreationApi extends BaseAPI {
    /**
     * 
     * @param {DareStatDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DareCreationApi
     */
    public async apiDareCreationCreatePut(body?: DareStatDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return DareCreationApiFp(this.configuration).apiDareCreationCreatePut(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DareCreationApi
     */
    public async apiDareCreationDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return DareCreationApiFp(this.configuration).apiDareCreationDeleteDelete(server, name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {DareStatDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DareCreationApi
     */
    public async apiDareCreationEditPost(body?: DareStatDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return DareCreationApiFp(this.configuration).apiDareCreationEditPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {boolean} [isDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DareCreationApi
     */
    public async apiDareCreationGetGet(server?: string, page?: number, itemsPerPage?: number, isDeleted?: boolean, options?: AxiosRequestConfig) : Promise<AxiosResponse<DareStatDtoPagedResponse>> {
        return DareCreationApiFp(this.configuration).apiDareCreationGetGet(server, page, itemsPerPage, isDeleted, options).then((request) => request(this.axios, this.basePath));
    }
}
